import { type RichiestaDTO } from '@framework/api-client/api/inquiries-compile/schemas/richiestaDTO.ts';
import { type RichiestaModuloDTO } from '@framework/api-client/api/inquiries-compile/schemas/richiestaModuloDTO.ts';
import { TableActionsCellSpace } from '@framework/ui/components/table/TableActionsCellSpace.tsx';
import { SummarySignatureModalButton } from '../SummarySignatureModalButton.tsx';
import { type IAttachmentTableRow } from './attachmentsColumns.tsx';
import { DownloadAttachmentButton } from './DownloadAttachmentButton.tsx';
import { GoToModuleButton } from './GoToModuleButton.tsx';

interface IAttachmentActionsCellProps {
  submissionId: string;
  record: IAttachmentTableRow;
  modules: RichiestaModuloDTO[];
  submission?: RichiestaDTO;
}

/**
 * Cella azioni per la tabella allegati nel riepilogo esteso.
 */
export function AttachmentActionsCell(props: IAttachmentActionsCellProps) {
  const { submissionId, record, modules, submission } = props;

  const attachmentId = record.attachment.id ?? '';
  const moduleId = record.attachment.idRichiestaModulo;
  const module = moduleId ? modules.find(m => m.id === moduleId) : undefined;

  return (
    <TableActionsCellSpace>
      <DownloadAttachmentButton
        submissionId={submissionId}
        attachmentId={attachmentId}
      />
      <DownloadAttachmentButton
        submissionId={submissionId}
        attachmentId={attachmentId}
        viewInline
        queryKeySuffix="inline-view"
      />
      {record.attachment.firmato && record.attachment.idFile && (
        <SummarySignatureModalButton
          size="small"
          signedFile={{
            uid: record.attachment.idFile,
            name: record.attachment.nomeFile ?? '-',
            size: record.attachment.dimensione ?? undefined,
            status: 'done',
          }}
          signatures={record.attachment.riepilogoDettagliFirma ?? undefined}
        />
      )}
      {!record.isOmissis && module && (
        <GoToModuleButton
          submissionId={submissionId}
          module={module}
          submission={submission}
        />
      )}
    </TableActionsCellSpace>
  );
}
